import { useState, useEffect } from "react";
// import useAxiosPrivate from "../hooks/useAxiosPrivate";
import axios from '../../api/axios';
// import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { formatDate } from "../../helpers/utils";
import LoadingModal from "../LoadingModal";

const Questions = () => {
    const [questions, setQuestions] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const getQuestionsController = new AbortController();

        const getQuestions = async () => {

            try {
                const response = await axios.get('/questions', {
                    signal: getQuestionsController.signal
                });
                if (isMounted) {
                    setQuestions(response.data);
                    setDataLoaded(true);
                }
            } catch (err) {
                if (isMounted) {
                    console.error(err);
                    // if (err.response?.status === 403) {
                    //     navigate('/login', { state: { from: location }, replace: true });
                    // }
                }
            }
        }

        getQuestions();

        return () => {
            isMounted = false;
            getQuestionsController.abort();
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    if (!dataLoaded) {
        return <LoadingModal />;
    }

    console.log(`Questions: render at ${new Date().getTime()}`);

    return (
        <section className="wide">
            <div className="toolbar">
                <h1>Questions</h1>
                <div className="toolbar">
                    <label>New:</label>
                    <Link to="/matrix/new">Matrix</Link>
                    <Link to="/multiplechoicequestion/new">Multiple choice</Link>
                    <Link to="/textquestion/new">Text</Link>
                    <Link to="/numericquestion/new">Numeric</Link>
                    <Link to="/constantsumquestion/new">Constant sum</Link>
                </div>
            </div>
            <div>
                {questions?.length
                    ? (
                        <table className="standard">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Type</th>
                                    <th>Text</th>
                                    <th>Status</th>
                                    <th>Edited</th>
                                </tr>
                            </thead>
                            <tbody>
                                {questions.map((question, i) => {
                                    let path;
                                    if (question.type === "text") {
                                        path = "textquestion"
                                    } else if (question.type === "numeric") {
                                        path = "numericquestion"
                                    } else if (question.type === "multiple choice") {
                                        path = "multiplechoicequestion"
                                    } else if (question.type === "matrix") {
                                        path = "matrix"
                                    } else if (question.type === "constant sum") {
                                        path = "constantsumquestion"
                                    }
                                    return (
                                        <tr key={i}>
                                            <td><Link to={`/${path}/edit/${question.questionId}`}>{question.questionId}</Link></td>
                                            <td>{question.type}</td>
                                            <td>{question.text}</td>
                                            <td>{question.status}</td>
                                            <td>{formatDate(new Date((Date.parse(question.lastModified))))}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    ) : <p>No questions to display</p>
                }
            </div>
        </section>
    );

};

export default Questions;